'use strict';
(function($){
	/*
	 * Vetology.PlatformControls widget
	 *
	 * @description This is the main Vetology PlatformControls widget that provides triggers for the different buttons on the platform
	 *
	 * @options	See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.PlatformControls',
		{
			"options": {
			},
			/*
			 * Vetology.PlatformControls._init
			 *
			 * @description	Initializes the Vetology.PlatformControls
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._initEventHandlers();
			},
			/*
			 * Vetology.Vetology._initEventHandlers
			 *
			 * @description	Adds handlers to the platform buttons
			 *
			 * @return NULL
			 *
			 */
			"_initEventHandlers": function(){
				$('body').on('click', '.viewActions', function(e){
					e.preventDefault();
					var clicked = $(this);
					var container = clicked.closest('.mainContainer');
					container.attr('style', '').removeClass('activeMenu');
					$('.viewActions').closest('.dropdown').removeClass('open');
					$('.viewActions').removeClass('vetology-menu-active');
					$('.row-actions').addClass('hide');
					var trigger = '.view_' + clicked.data('view');
					if($(this).data('displayed')){
						$(trigger).addClass('hide');
						$('.viewActions').data('displayed', false);
						clicked.removeClass('vetology-menu-active');
					} else {
						$(trigger).removeClass('hide');
						$('.viewActions').data('displayed', false);
						clicked.data('displayed', true).addClass('vetology-menu-active');
						clicked.closest('.dropdown').addClass('open');
						container.height(container[0].scrollHeight + 30).addClass('activeMenu');
					}
				});
			}
		}
	);
})(jQuery);